export default {
	async created() {
		const lang = this.$route.query?.lang || this.user?.data?.language

		if (lang && this.$i18n.locales.some(locale => locale.code === lang)) {
			this.$i18n.setLocale(lang)
		} else {
			this.$i18n.setLocale('en')
		}
	},
}
